<template>
  <div
    :class="settings.isPro ? 'pointer-events-none' : 'cursor-pointer'"
    @click="handleUpgrade"
  >
    <div
      :style="[isSmall ? { fontSize: '8px' } : { fontSize: '10px' }]"
      :class="[
        isWhite ? 'border-white border' : 'gradient',
        isSmall ? '' : 'py-1',
        isHail ? '' : '',
      ]"
      class="px-2 font-bold text-white rounded-xl uppercase"
    >
      <span v-if="!isHail"> Pro </span>
      <span v-else class="">
        Hail
        <!-- <img class="w-4 filter grayscale brightness-150" src="/img/tenant1/mail/hail-icon.png" alt="Hail logo"> -->
      </span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    config: { default: null },
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),

    isWhite() {
      return this.config?.white
    },

    isSmall() {
      return this.config?.small
    },

    isHail() {
      return this.config?.hail
    },
  },

  methods: {
    handleUpgrade() {
      if (!this.settings.isPro) {
        EventBus.$emit('showModal', {
          action: 'cw-registration',
          data: {
            reason: 3,
          },
        })
      }
    },
  },
}
</script>

<style scoped>
.gradient {
  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));
  background: linear-gradient(45deg, var(--cw-700), var(--cw-alt));
}
</style>
